import { ClipboardCheck, PackageCheck, Settings } from "lucide-react"
import type { AreaNavItem } from "@/components/AppHeader"

/**
 * Separadores da área Armazém: Receções · Ronda · Configurações. A Ronda
 * (0.32.0) substitui os separadores Contagem e Conferência.
 * Carregar uma fatura faz-se na própria lista (a rota `/armazem/nova` fica para
 * as várias fotos da mesma fatura no telemóvel).
 */
export const ARMAZEM_NAV: AreaNavItem[] = [
  { to: "/armazem", label: "Receções", icon: PackageCheck, end: true },
  { to: "/armazem/ronda", label: "Ronda", icon: ClipboardCheck },
  { to: "/armazem/configuracoes", label: "Configurações", icon: Settings, adminOnly: true },
]
